// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
Rails.start()
Turbolinks.start()
ActiveStorage.start()

import "bootstrap"
import "packs/custom/table2csv.min"
import "packs/custom/airports"
import "packs/custom/reports"
import "packs/custom/procurement"
import "packs/custom/diversity_procurement"
import Chart from 'chart.js/auto';

import "@fortawesome/fontawesome-free/js/all";

require("jquery")
require("@nathanvda/cocoon")
require('popper.js');


import $ from 'jquery';
import 'select2';
global.$ = $
global.jQuery = $


require('jquery-ui');
import "chartkick/chart.js"
// import "bootstrap-multiselect"
// require.context('file-loader?name=[path][name].[ext]&context=node_modules/jquery-ui-dist!jquery-ui-dist', true, /jquery-ui\.css/);
// require.context('file-loader?name=[path][name].[ext]&context=node_modules/jquery-ui-dist!jquery-ui-dist', true, /jquery-ui\.theme\.css/);

import "packs/custom/chosen.jquery"

document.addEventListener('turbolinks:load', () => {
  var categoryChart = document.getElementById('categoryChart');
  if (categoryChart) {
    var ctx = categoryChart.getContext('2d');
    var myChart = new Chart(ctx, {
    type: 'bar',
    data: {
      labels: JSON.parse(ctx.canvas.dataset.labels),
      datasets: [{
        label: 'No of vendor for Small Business and Diversity Spend metrics',
        data: JSON.parse(ctx.canvas.dataset.data),
        borderColor:"#9ecef4",
        backgroundColor: "#9ecef4",
        pointBackgroundColor: "#9ecef4",
        pointBorderWidth: 2,
        pointHoverBackgroundColor: "#9ecef4",
        pointHoverBorderWidth: 2,
        lineTension:0.05
      }]
    },
    });
  } 

  var certificateChart = document.getElementById('certificateChart');
  if (certificateChart) {
    var ctx2 = certificateChart.getContext('2d');
    var myChart = new Chart(ctx2, {
    type: 'bar',
    data: {
      labels: JSON.parse(ctx2.canvas.dataset.labels),
      datasets: [{
        label: 'No of certified verndor for each category',
        data: JSON.parse(ctx2.canvas.dataset.data),
        borderColor:"#9fbba5",
        backgroundColor: "#9fbba5",
        pointBackgroundColor: "#9fbba5",
        pointBorderWidth: 2,
        pointHoverBackgroundColor: "#9fbba5",
        pointHoverBorderWidth: 2,
        lineTension:0.05
      }]
    },
    });
  }
})